import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { PrimaryButton } from "../../../layout/Button/Button";
import { useAuth } from "../../../../contexts/auth.context";

interface StoryViewHeaderProps {
    storyName: string;
    onEdit?: () => void;
    onApprove?: () => void;
    onPublish?: () => void;
    isReviewed?: boolean;
    isPublished?: boolean;
    loading?: boolean;
}

export const StoryViewHeader: React.FC<StoryViewHeaderProps> = ({
    storyName,
    onEdit,
    onApprove,
    onPublish,
    isReviewed = false,
    isPublished = false,
    loading = false,
}): JSX.Element => {
    const { hasPermission } = useAuth();

    return (
        <Grid container item xs={12} alignItems="center" justifyContent="space-between">
            <Grid item>
                <Box mb={1}>
                    <Typography variant={"h4"}>Story Name</Typography>
                </Box>
                <Typography>{storyName}</Typography>
            </Grid>
            <Grid item container spacing={1} alignItems="center" justifyContent="flex-end" style={{ width: "auto" }}>
                {onEdit && hasPermission("StoryUpdate") && (
                    <Grid item>
                        <PrimaryButton onClick={onEdit} disabled={loading}>
                            Edit
                        </PrimaryButton>
                    </Grid>
                )}
                {onApprove && hasPermission("StoryReview") && !isReviewed && (
                    <Grid item>
                        <PrimaryButton onClick={onApprove} disabled={loading}>
                            Approve
                        </PrimaryButton>
                    </Grid>
                )}
                {onPublish && hasPermission("StoryPublish") && isReviewed && !isPublished && (
                    <Grid item>
                        <PrimaryButton onClick={onPublish} disabled={loading}>
                            Publish
                        </PrimaryButton>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};
